<template>
    <b-row>
        <b-col cols="12">
            <h2 class="m-0 h1 text-uppercase">
                {{ $t('perfil_invitaciones.selecciona_butacas') }}
            </h2>
        </b-col>
        <b-col cols="12" class="mt-3">
            <ContentOrLoading>
                <transition name="fade" mode="out-in" v-if="!loading">
                    <b-row key="zonas" id="zonas">
                        <b-col cols="12" md="4">
                            <div class="oswald text-uppercase">{{ $t('nuevo_abono.zona_seleccionada') }}:</div>
                            <span class="h3 mb-4 mb-lg-2 d-flex justify-content-between align-items-end">
                                {{ zona.name }}
                            </span>

                            <button @click="$emit('cambiarZona')" class="h6 button small-button mb-2" ><i class="fa fa-redo"></i> {{ $t('partido.cambiar_zona') }}</button>
                            
                            <template v-if="asientos_seleccionados.length">
                                <TusAsientosComponent 
                                    :asientos="asientos_seleccionados"
                                    :loading="loading"
                                    @eliminarAsiento="eliminarAsiento"
                                />
    
                                <button
                                    :class="frontend ? 'button large-button effect-button sitecolor-content rounded' : 'btn btn-primary mt-1 w-100'"
                                    @click="bloquearAsientos"
                                >
                                    <span>{{ $t('partido.continuar_compra') }}</span>
                                </button>
                            </template>
                        </b-col>
                        <b-col cols="12" md="8" class="order-first order-lg-last">
                            <ContentOrLoading>
                                <AsientosComponent
                                    ref="asientosComp"
                                    :asientos="asientos_seleccionados"
                                    :asientos_maximos="max_asientos"
                                    :compra_invitaciones="true"
                                    :zona="conf_asientos"
                                    :puedo_cambiar="true"
                                    @changeAnySelected="onChangeAnySelected"
                                    @validoAsientos="onValidoAsientos"
                                />
                            </ContentOrLoading>
                        </b-col>
                    </b-row>
                </transition>
            </ContentOrLoading>
        </b-col>
    </b-row>
</template>

<script>
    import AsientosComponent from '@/components/frontend/events/compra/AsientosComponent.vue';
    import TusAsientosComponent from './TusAsientosComponent';

    export default {
        props: {
            zona: {
                type: Object,
                required: true
            },
            event_id: {
                type: [String, Number],
                required: true
            },
            sesion_id: {
                type: [String, Number],
                required: true
            },
            abono_id: {
                type: [String, Number],
                required: true
            },
            max_asientos: {
                type: Number,
                required: true
            },
            frontend: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                loading: false,
                conf_asientos: [],
                asientos_validos: true,
                alguno_seleccionado: false,
                asientos_seleccionados: []
            } 
        },
        methods: {
            finalizarPasoDos(butacas) {
                this.$emit('terminado', butacas);
            },
            getAsientos() {
                this.loading = true;
                const params = {
                    abonado_id: this.abono_id,
                    evento_id: this.event_id,
                    sesion_id: this.sesion_id,
                    zona_id: this.zona.id,
                }
                const alias = this.frontend
                    ? 'front.perfil.invitaciones.asientos'
                    : 'back.abonados.abono.invitaciones.asientos';

                this.$store.dispatch(this.config.getVuexAlias(alias), params).then(res => {
                    this.conf_asientos = res.data.data;
                }).finally(() => {
                    this.loading = false;
                });
            },
            eliminarAsiento(asiento) {
                if (!asiento) return;

                const fila = asiento.asiento.fila;
                const asientoNum = asiento.asiento.asiento;

                this.$refs.asientosComp.toggleSeleccion(fila, asientoNum);

                const idx = this.asientos_seleccionados.findIndex(s =>
                    s.asiento && s.asiento.fila == fila && s.asiento.asiento == asientoNum
                );
                if (idx !== -1) this.asientos_seleccionados.splice(idx, 1);
            },
            onValidoAsientos(esValido) {
                this.asientos_validos = esValido;
            },
            onChangeAnySelected(haySeleccionados) {
                this.alguno_seleccionado = haySeleccionados;
            },
            bloquearAsientos() {
                this.loading = true;
                
                const params = {
                    filters: {},
                    abonado_id: this.abono_id,
                    evento_id: this.event_id,
                    sesion_id: this.sesion_id,
                    asientos: this.asientos_seleccionados.map(item => item.asiento)
                }
                const alias = this.frontend
                    ? 'front.perfil.invitaciones.bloquear-asientos'
                    : 'back.abonados.abono.invitaciones.bloquear-asientos';

                this.$store.dispatch(this.config.getVuexAlias(alias), params).then(res => {
                    this.$emit('setSessionId', res.data.session_id, this.asientos_seleccionados);
                })
                    .catch(error => {
                        this.$toast.error(error?.response?.data?.message);
                        this.asientos_seleccionados = [];
                        this.getAsientos();
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        created() {
            this.getAsientos();
        },
        components: {
            AsientosComponent, TusAsientosComponent
        }
    }
</script>